import { withNamespaces } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

const defaultOptions = {
    placeholder: 'Search',
    typingDelay: 0
}

const getOption = (option, options) => {
    if(!(option in (options || {}))) return defaultOptions[option];

    return options[option];
}

const SearchTextBox = withNamespaces()(({
    t,
    name,
    defaultValue,
    options = {},
    onFilterChange,
    idPrefix = '',
    displayIndependently
}) => {
    const [value, setValue] = useState(defaultValue)
    const [debouncedValue, setDebouncedValue] = useState(defaultValue)
    const typingDelay = getOption('typingDelay', options)
    const initRef = useRef(false);

    useEffect(() => {
        const timeoutRef = setTimeout(() => {
            setDebouncedValue(value);
        }, typingDelay);

        return () => {
            clearTimeout(timeoutRef);
        };
    }, [value])

    useEffect(() => {
        onFilterChange &&
            onFilterChange({
                filterName: name,
                value: value
            })
    }, [debouncedValue])

    useEffect(() => {
        if(!initRef.current){
            initRef.current = true;
            return;
        }
        
        if(displayIndependently){
            setValue(defaultValue || '')
        }
    }, [ defaultValue ])

    const placeholder = getOption('placeholder', options)

    return (
        <div className='filter-items-container'>
            <div className="filter-item">
                <InputGroup>
                    <InputGroup.Text
                        className='bg-transparent border-left-0'
                        id={`${idPrefix}-search_input__${name}`}
                    >
                        <i className='ri-search-line' />
                    </InputGroup.Text>
                    <Form.Control
                        id={`${idPrefix}-search_textbox__${name}`}
                        placeholder={`${t(placeholder)}...`}
                        aria-describedby={`${idPrefix}-search_input__${name}`}
                        style={{
                            fontWeight: 500,
                            color: '#4F4F4F'
                        }}
                        onChange={(e) => {
                            setValue(e.target.value)
                        }} 
                        defaultValue={defaultValue}
                        value={value}
                    />
                </InputGroup>
            </div>
        </div>
    )
})

export { SearchTextBox }
